<template>
  <div class="variant">
    <amen title="지도로 한 눈에 보기" type="true" more="store" />

    <image-three
      title="여행버튼"
      highlighten="HOT PICK"
      type="true"
      more="store"
    />
    <carousel />

    <!-- <HomeMagazine /> -->

    <image-three title="국내 여행지" type="1" more="locations" />
  </div>
</template>

<style scoped>
.variant {
  height: 1450px;
}

@media screen and (max-width: 420px) {
  .variant {
    height: 1150px;
  }
}

iframe {
  height: 100%;
}
</style>

<script>
import ImageThree from "./image-three";
import Carousel from "./carousel";
import HomeMagazine from "./home-magazine";
import Amen from "./amen";

export default {
  components: { ImageThree, Carousel, HomeMagazine, Amen },
  methods: {
    show() {
      this.$modal.show("my-first-modal");
    },
    hide() {
      this.$modal.hide("my-first-modal");
    },
  },
};
</script>
